export default (value) => (value >= 1000 ? "999+" : value)
